export enum MixpanelFlags {
  SRP_RIDE_CROSS_SELL_CARD = 'srp_ride_cross_sell_card_web',
}
